export const normalizeStringData = (date: string): string => {
    if(!date) return '';

    return date.replaceAll('/', '-').split('-').reverse().join('-')
}

export const normalizeDateTimeZoneInString = (date: string): string => {
    if(!date) return '';

    return date.split('T')[0]
}

export const normalizeDateToInputCalendar = (date: string): string => {
    if(!date) return '';

    return date.replaceAll('-', '/').split('/').reverse().join('/')
}